import React from "react";
import styles from "./KnowledgeSourceDropdown.module.css";
import { InputLabel } from "../../ui-library/InputLabel/InputLabel.tsx";
import { LoadingDots } from "../../ui-library/LoadingDots/LoadingDots.tsx";
import { Dropdown } from "../../ui-library/Dropdown/Dropdown.tsx";

export type KnowledgeSource = {
  label: string;
  value: string;
  repoUrl?: string;
};

type FeatureFlags = {
  enableIngestionFolderLink?: boolean;
  enableChatFirstPage?: boolean;
};

const noKnowledgeSourcesStyle = {
  color: "rgba(207, 207, 207, 0.86)",
  marginLeft: "1em",
};

export function KnowledgeSourceDropdown(props: {
  knowledgeSourcesLoading: boolean | undefined;
  knowledgeSources: KnowledgeSource[];
  selectedSource: KnowledgeSource | undefined;
  onSelect: (value: Array<string | object>) => void;
  featureFlags: FeatureFlags;
  onClick: (event: React.MouseEvent) => void;
  showLabel?: boolean;
}) {
  const plusIconClass = props.featureFlags.enableChatFirstPage
    ? undefined
    : styles.PlusIcon;
  const addFilesTextClass = props.featureFlags.enableChatFirstPage
    ? undefined
    : styles.AddFilesText;
  return (
    <>
      {(props.showLabel ?? true) && (
        <InputLabel number={1} size={"large"}>
          Select Knowledge Source *
        </InputLabel>
      )}
      {props.knowledgeSourcesLoading ? (
        <LoadingDots />
      ) : props.knowledgeSources.length === 0 ? (
        <span style={noKnowledgeSourcesStyle}>
          "No knowledge sources found for your account"
        </span>
      ) : (
        <div className={styles.KnowledgeSourceContainer}>
          <Dropdown
            items={props.knowledgeSources}
            placeholder="Select source"
            selected={props.selectedSource ? [props.selectedSource.value] : []}
            onSelect={props.onSelect}
            sorting="alphabetical"
            searchable
          />
          {props.featureFlags.enableIngestionFolderLink &&
            props.selectedSource?.repoUrl && (
              <a className={styles.AddFilesLink} onClick={props.onClick}>
                <span className={plusIconClass}>+</span>
                <span className={addFilesTextClass}>
                  Add files to this Knowledge Source
                </span>
              </a>
            )}
        </div>
      )}
    </>
  );
}
